// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-block[data-v-0f859045]{font-size:16px;padding:5px 10px;transition:background-color .1s ease;width:100%}.contact-block[data-v-0f859045]:hover{background-color:#f2f2f2}.partner-label[data-v-0f859045]{color:#5e6163;font-size:14px}.header[data-v-0f859045]{font-size:18px!important}.interactive[data-v-0f859045]{cursor:pointer}.field[data-v-0f859045]{font-weight:500!important}.field span[data-v-0f859045]{font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
